module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Venue"
  }, [_c('div', {
    staticClass: "container is-fluid"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "columns is-centered"
  }, [_c('div', {
    staticClass: "column is-12 content"
  }, [_c('a', {
    attrs: {
      "href": "https://www.openstreetmap.org/node/1096120193",
      "target": "_blank"
    }
  }, [_vm._v("Open Street Map")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.google.com/maps/place/Progressbar+hackerspace/@48.144557,17.1133019,17z/data=!3m1!4b1!4m5!3m4!1s0x476c8946152ff129:0x72ac0b6fccaf66fd!8m2!3d48.144557!4d17.1154906",
      "target": "_blank"
    }
  }, [_vm._v("Google Maps")]), _vm._v(" "), _c('iframe', {
    staticStyle: {
      "border": "1px solid black"
    },
    attrs: {
      "width": "100%",
      "height": "600",
      "frameborder": "0",
      "scrolling": "no",
      "marginheight": "0",
      "marginwidth": "0",
      "src": "https://www.openstreetmap.org/export/embed.html?bbox=17.113958001136783%2C48.143727459609195%2C17.116854786872867%2C48.14537578584775&layer=mapnik&marker=48.14455162934517%2C17.115406394004822",
      "loading": "lazy"
    }
  }), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "tile is-vertical is-12"
  }, _vm._l((_vm.href.iframes), function(frame) {
    return _c('div', {
      staticClass: "column contains-iframe-to-center"
    }, [_c('ImageFrame', {
      key: frame,
      attrs: {
        "url": frame
      }
    })], 1)
  }), 0)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns is-centered"
  }, [_c('div', {
    staticClass: "column is-5 content"
  }, [_c('h2', {
    staticClass: "has-text-white"
  }, [_vm._v("\n          📍 We are located on the first floor. "), _c('br'), _vm._v("\n          🚶‍♀️ You can access our space through grey doors next to the bike stand."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" 🚪 If you plan visit us during day, let us know in advance, so we can count on you.\n          "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Before visit, "), _c('a', {
    attrs: {
      "href": "https://t.me/coworkprogressbar"
    }
  }, [_vm._v("join our public telegram channel ahead ")]), _vm._v(" or "), _c('a', {
    attrs: {
      "href": "mailto:info@progressbar.sk"
    }
  }, [_vm._v("contact us via email")]), _vm._v("."), _c('br'), _vm._v("\n          See you soon 👋\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "column is-4 is-offset-2 content"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-12 content"
  }, [_c('h1', {
    staticClass: "has-text-white"
  }, [_vm._v("\n            📯Address - postal "), _c('br')]), _vm._v(" "), _c('h3', {
    staticClass: "has-text-white"
  }, [_vm._v("\n            Progressbar cowork & hackerspace,"), _c('br'), _vm._v("\n            Dunajská 7495/14,"), _c('br'), _vm._v("\n            811 08 Bratislava"), _c('br'), _vm._v("\n            Slovakia"), _c('br')])])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-12 content"
  }, [_c('h1', {
    staticClass: "has-text-white"
  }, [_vm._v("\n            🧾 Billing details\n          ")]), _vm._v(" "), _c('h4', {
    staticClass: "has-text-white"
  }, [_vm._v("\n            Progressbar o.z."), _c('br'), _vm._v("\n            Dunajská 7495/14,"), _c('br'), _vm._v("\n            81108 Bratislava,"), _c('br'), _vm._v("\n            Slovenská republika"), _c('br'), _vm._v("\n\n            IČO: 42180023"), _c('br'), _vm._v("\n            DIČ: 2023612074"), _c('br'), _vm._v("\n\n            Registrované na MVSR zo dňa 15.7.2010 číslo spisu VVS/1-900/90-35964\n          ")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2f9d4030","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContactVenue.vue
// module id = 244
// module chunks = 10